/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _immutable = require('immutable');

var _actions = require('reduxPath/actions');

var Actions = _interopRequireWildcard(_actions);

var _tool = require('util/tool');

var _tpl = require('tpl');

var _tpl2 = _interopRequireDefault(_tpl);

var _home = require('./home');

var _home2 = _interopRequireDefault(_home);

var _list = require('./list');

var _list2 = _interopRequireDefault(_list);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);
    return (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));
  }

  (0, _createClass3.default)(Main, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          fetchDeviceProductDetail = _props.fetchDeviceProductDetail,
          params = _props.params;


      var id = params.id;
      fetchDeviceProductDetail({ productId: id });
    }
  }, {
    key: 'copyText',
    value: function copyText(text) {
      copy.handle(text);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          device = _props2.device,
          params = _props2.params,
          router = _props2.router;


      var data = device.product;
      data = data || {};
      //console.log(data)
      return (0, _jsx3.default)('div', {
        className: 'device-home',
        id: 'device-index'
      }, void 0, data.deviceCount > 0 ? (0, _jsx3.default)(_list2.default, {
        device: device,
        deviceList: device.deviceList,
        deviceProduct: device.deviceProduct,
        params: params,
        router: router
      }) : (0, _jsx3.default)(_home2.default, {
        params: params,
        router: router
      }));
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _tpl2.default)({
  id: 'device-index', // 应用关联使用的redux
  component: Main, // 接收数据的组件入口
  url: ''
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/device/index.jsx
// module id = 827
// module chunks = 0